const arseMentions = (text, fromMe, mentionStyle = {}) => {
  const mentionRegex = /@\[(\d+)\]\(([^)]+)\)/g;
  const parts = [];
  let lastIndex = 0;

  let match;
  while ((match = mentionRegex.exec(text)) !== null) {
    const id = match[1];
    const name = match[2];
    const offset = match.index;

    if (offset > lastIndex) {
      parts.push(text.substring(lastIndex, offset));
    }

    parts.push(
      <span
        key={`${id}-${offset}`}
        style={{
          backgroundColor: fromMe ? "#42B1FC" : "#0D4B82",
          padding: "0px 10px",
          paddingTop:"3px",
          paddingBottom:"6px",
          borderRadius: "15px",
          color: "white",
          ...mentionStyle, // Allow custom styles
        }}
      >
        @{name}
      </span>
    );

    lastIndex = offset + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts;
};

export default arseMentions;